import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Shopping Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-shopping-outline',
    templateUrl: './icon-shopping-outline.component.html',
    styleUrls: ['./icon-shopping-outline.component.scss'],
    standalone: false
})
export class IconShoppingOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
